// test1356
(1356 && 0);
